//React imports
import React from 'react';

//MUI Imports
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

//MUI Icons Imports
import VrpanoIcon from '@mui/icons-material/Vrpano';
import { getNames } from '../../services/stacks';
import { getUserData } from '../../services/auth';
import { clientNetwork } from '../../lib/constants';

const UploadThumbnailAttachmentComponent = ({ btnDisable, open, setShowBnsWarningModal }) => {
    async function upload() {
        // getNames(getUserData().profile.stxAddress.testnet).then(({ success }) => {
        //getNames(getUserData().profile.stxAddress.mainnet).then(({ success }) => {    
        // if (success) {
        open();
        // } else {
        //     setShowBnsWarningModal(true);
        // }
        // })
    }

    return (
        <Tooltip title="Add Thumbnail: PNG must be 1280 x 720 px and no larger than 20mb">
            <IconButton onClick={upload} disabled={btnDisable} id="thumbnail-icon" aria-label="Upload ThumNail" component="label">
                <VrpanoIcon size={24} />
            </IconButton>
        </Tooltip>
    );
}

export default UploadThumbnailAttachmentComponent;
